import { openDB, executeTx } from '../database/db';
import { dateUtils } from '../utils/dateUtils';

export const projectRepository = {
  getAll: async () => {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx = db.transaction('projects', 'readonly');
      const store = tx.objectStore('projects');
      const req = store.getAll();
      req.onsuccess = () => {
        const projects = req.result || [];
        if (projects.length === 0) {
          // افتتاح پروژه پیش‌فرض اولیه
          const defaultProj = {
            id: 'proj-default-101',
            metadata: {
              title: 'پروژه بهسازی و احداث باند دوم محور اصلی',
              client: 'اداره کل راهداری و حمل‌ونقل جاده‌ای',
              consultant: 'مهندسین مشاور سازه و راه',
              contractor: 'شرکت مهندسی و ساختمانی آکام',
              location: 'کیلومتر ۱۲ الی ۱۵ محور اصلی'
            },
            createdAt: dateUtils.now(),
            status: 'active'
          };
          projectRepository.create(defaultProj).then(() => resolve([defaultProj]));
        } else {
          resolve(projects);
        }
      };
    });
  },

  getById: async (id) => {
    return executeTx('projects', 'readonly', (tx) => {
      return new Promise((resolve) => {
        const req = tx.objectStore('projects').get(id);
        req.onsuccess = () => resolve(req.result || null);
      });
    });
  },

  create: async (projectData) => {
    const project = {
      id: projectData.id || 'proj-' + dateUtils.now(),
      metadata: projectData.metadata || {},
      createdAt: projectData.createdAt || dateUtils.now(),
      status: projectData.status || 'active'
    };

    await executeTx('projects', 'readwrite', (tx) => {
      tx.objectStore('projects').put(project);
    });
    return project;
  },

  delete: async (projectId) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(['projects', 'records', 'files'], 'readwrite');
      tx.objectStore('projects').delete(projectId);

      // پاکسازی رکوردهای وابسته
      const recIndex = tx.objectStore('records').index('projectId');
      recIndex.getAllKeys(projectId).onsuccess = (e) => {
        e.target.result.forEach((k) => tx.objectStore('records').delete(k));
      };

      // پاکسازی فایل‌های باینری وابسته
      const fileIndex = tx.objectStore('files').index('projectId');
      fileIndex.getAllKeys(projectId).onsuccess = (e) => {
        e.target.result.forEach((k) => tx.objectStore('files').delete(k));
      };

      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  },

  // مدیریت پروژه فعال در استور settings
  getActiveProjectId: async () => {
    try {
      const db = await openDB();
      return new Promise((resolve) => {
        const tx = db.transaction('settings', 'readonly');
        const req = tx.objectStore('settings').get('activeProject');
        req.onsuccess = () => {
          const val = req.result ? req.result.value : localStorage.getItem('civil_nexus_active_project_id');
          resolve(val || 'proj-default-101');
        };
      });
    } catch (e) {
      return localStorage.getItem('civil_nexus_active_project_id') || 'proj-default-101';
    }
  },

  setActiveProjectId: async (id) => {
    localStorage.setItem('civil_nexus_active_project_id', id);
    try {
      await executeTx('settings', 'readwrite', (tx) => {
        tx.objectStore('settings').put({ key: 'activeProject', value: id });
      });
    } catch (e) {}
  }
};
